import React from "react";
import { heroStats, heroImage } from "../mock";
import { Button } from "./ui/button";
import { ArrowRight, Sparkles } from "lucide-react";

export default function Hero() {
  return (
    <section className="relative pt-36 lg:pt-44 pb-20 lg:pb-28 overflow-hidden bg-white">
      {/* Decorative shapes */}
      <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-brand-light animate-blob" />
      <div className="absolute top-40 -right-20 w-80 h-80 rounded-full bg-brand-light opacity-70 animate-blob" style={{ animationDelay: "3s" }} />
      <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: "radial-gradient(#A11933 1px, transparent 1px)", backgroundSize: "24px 24px" }} />

      <div className="relative max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
        <div className="animate-fade-up">
          <div className="section-label mb-6">Lead Matrix Business Solutions</div>
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-gray-900 leading-[1.05] spaced-heading">
            YOUR <span className="text-brand">FUTURE</span>,<br />OUR EXPERTISE
          </h1>
          <p className="mt-6 text-lg text-gray-600 max-w-xl leading-relaxed">
            Talent. Growth. Careers. BPO. Innovation. Partnership.
            <br />
            We drive career success and business growth through expert recruitment, corporate training, and end-to-end BPO solutions.
          </p>

          <div className="mt-8 flex flex-wrap gap-4">
            <Button asChild className="bg-brand hover:bg-brand-dark text-white rounded-full h-12 px-7 text-sm font-semibold group">
              <a href="#services">
                Explore Services <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} />
              </a>
            </Button>
            <Button asChild variant="outline" className="border-2 border-brand text-brand hover:bg-brand hover:text-white rounded-full h-12 px-7 text-sm font-semibold">
              <a href="#contact">Join Now</a>
            </Button>
          </div>

          <div className="mt-12 flex gap-10">
            {heroStats.map((s) => (
              <div key={s.id}>
                <div className="flex items-baseline gap-1">
                  <span className="font-display text-5xl font-bold text-gray-900">{s.value}</span>
                  <span className="text-3xl font-bold text-brand">{s.suffix}</span>
                </div>
                <div className="text-sm text-gray-500 mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative animate-fade-up" style={{ animationDelay: "0.2s" }}>
          <div className="relative rounded-[2rem] overflow-hidden bg-brand-light aspect-[4/5] max-w-md ml-auto">
            <img src={heroImage} alt="Lead Matrix Professional" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-brand/20 to-transparent" />
          </div>

          {/* Floating badge */}
          <div className="absolute -bottom-6 -left-4 lg:-left-8 bg-white rounded-2xl shadow-xl p-5 flex items-center gap-3 border border-gray-100">
            <div className="w-12 h-12 rounded-full bg-brand flex items-center justify-center text-white">
              <Sparkles size={22} />
            </div>
            <div>
              <div className="font-bold text-gray-900">95%</div>
              <div className="text-xs text-gray-500">Placement Success</div>
            </div>
          </div>

          <div className="absolute top-6 -right-4 bg-white rounded-2xl shadow-xl px-4 py-3 border border-gray-100">
            <div className="text-xs text-gray-500">Trusted by</div>
            <div className="font-bold text-gray-900">500+ Clients</div>
          </div>
        </div>
      </div>
    </section>
  );
}
